import type { AudienceListType, FormSegment } from '../../../types';
import { PredefinedSegmentType } from '../constants';

export type BasePredefinedProps = {
  rtgSegments: FormSegment[];
  thirdPartySegments: FormSegment[];
  siteCategorySegments: FormSegment[];
  oxPurchaseSegments: FormSegment[];
  listType: AudienceListType;
};
export const getPredefinedSegments = (segments: FormSegment[]) => {
  const result: Omit<BasePredefinedProps, 'listType'> = {
    rtgSegments: [],
    thirdPartySegments: [],
    siteCategorySegments: [],
    oxPurchaseSegments: [],
  };

  for (const segment of segments) {
    switch (segment.sub_category) {
      case PredefinedSegmentType.PartnerAudiences:
        result.rtgSegments.push(segment);
        break;
      case PredefinedSegmentType.ThirdPartyData:
        result.thirdPartySegments.push(segment);
        break;
      case PredefinedSegmentType.PastBrowsingInterests:
        result.siteCategorySegments.push(segment);
        break;
      case PredefinedSegmentType.OxPurchaseData:
        result.oxPurchaseSegments.push(segment);
        break;
    }
  }

  return result;
};
